module.exports = __webpack_public_path__ + "static/media/largeMedal_3.03be08e4.png";